import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Note } from '../..';
import { Box } from 'rebass';
export const title = 'MDX';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "mdx"
    }}>{`MDX`}</h1>
    <p><a parentName="p" {...{
        "href": "https://mdxjs.com"
      }}>{`MDX`}</a>{` is a format that allows you to write content in markdown and import and use React components inline.
It's an excellent format for documentation, blogs, or other forms of structured content.`}</p>
    <Note mdxType="Note">
      <p>{`This guide is a work-in-progress.
If you'd like to help make this better,
please open an issue or pull request on `}<a parentName="p" {...{
          "href": "https://github.com/rebassjs/rebass"
        }}>{`GitHub`}</a>{`.`}</p>
    </Note>
    <p>{`Rebass components can be imported and used directly in MDX documents,
which lets you apply styles inline to sections of your page.
Since the `}<inlineCode parentName="p">{`sx`}</inlineCode>{` prop is built into the components, this can be a quick way to apply one off styles or create custom components like callouts and note boxes.`}</p>
    <p>{`In the following example, the Box component is used to add a callout style box around its contents.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-md"
      }}>{`import { Box } from 'rebass'

# MDX Example

<Box
  color='primary'
  bg='muted'
  p={3}
  my={5}
>

> ”This is an important quote.”

</Box>
`}</code></pre>
    <p>{`You can also use the `}<inlineCode parentName="p">{`sx`}</inlineCode>{` prop with child selectors to dramatically change the layout of MDX content.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-md"
      }}>{`import { Box } from 'rebass'

# MDX Example

<Box
  sx={{
    ul: {
      listStyle: 'none',
      display: 'grid',
      padding: 0,
      gridGap: 3,
      gridTemplateColumns: 'repeat(auto-fit, minmax(128px, 1fr))',
    },
    li: {
      fontWeight: 'bold',
    }
  }}>

- This is a list
- Displayed in a grid layout
- With custom styles
- Pretty cool, huh?

</Box>
`}</code></pre>
    <p>{`If you make repeated use of a particular layout block, consider moving it to its own component that can be imported in multiple MDX documents.`}</p>
    <Note mdxType="Note">
      <p>{`If you'd like to style the markdown elements with the same theme object and a similar API to Rebass,
use the `}<a parentName="p" {...{
          "href": "https://theme-ui.com"
        }}>{`Theme UI`}</a>{` library, which includes first-class support for styling MDX content.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      